<style lang="scss" scoped>
.page-wrap {
  padding: 8px 0 80px;
  font-family: 'Segoe UI', sans-serif;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: hidden;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #eef2fb;
  border-bottom: 1px solid #dde4f5;

  .panel-title {
    font-size: 13px;
    font-weight: 700;
    color: #389ad4;
    display: flex;
    align-items: center;
    gap: 8px;

    .provider-name {
      color: #0d1b3e;
      font-weight: 600;
    }
  }

  .btn-back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 14px;
    background: #fff;
    color: #4a5568;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: #389ad4;
      color: #389ad4;
    }
  }
}

/* ── Toolbar ── */
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f3fa;
  flex-wrap: wrap;

  .search-box {
    position: relative;
    flex: 1;
    min-width: 180px;
    max-width: 300px;

    i {
      position: absolute;
      left: 11px;
      top: 50%;
      transform: translateY(-50%);
      color: #a0aab8;
      font-size: 13px;
      pointer-events: none;
    }

    input {
      width: 100%;
      height: 36px;
      border: 1.5px solid #dde2ec;
      border-radius: 8px;
      padding: 0 12px 0 32px;
      font-size: 13px;
      color: #0d1b3e;
      outline: none;
      transition: border-color 0.2s;

      &::placeholder {
        color: #b0bac9;
      }

      &:focus {
        border-color: #389ad4;
        box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
      }
    }
  }

  .btn-add {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    padding: 0 16px;
    background: #F58020;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.2s;
    white-space: nowrap;

    &:hover {
      opacity: 0.9;
    }
  }
}

/* ── Table ── */
.users-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
  table-layout: fixed;

  thead tr th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7a8499;
    padding: 10px 10px;
    border-bottom: 2px solid #eef0f8;
    background: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f8fbff;
    }

    td {
      padding: 10px 10px;
      color: #2d3748;
      vertical-align: middle;
    }
  }
}

/* ── Toggle switch ── */
.switch-wrap {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 22px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    inset: 0;
    background: #cbd5e0;
    border-radius: 22px;
    cursor: pointer;
    transition: background 0.2s;

    &::before {
      content: '';
      position: absolute;
      width: 16px;
      height: 16px;
      left: 3px;
      top: 3px;
      background: #fff;
      border-radius: 50%;
      transition: transform 0.2s;
    }
  }

  input:checked+.slider {
    background: #389ad4;
  }

  input:checked+.slider::before {
    transform: translateX(16px);
  }
}

/* ── Action dropdown ── */
.action-wrap {
  position: relative;
  display: inline-block;

  .action-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: #f5f7fa;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #4a5568;
    letter-spacing: 1px;
    transition: background 0.15s;

    &:hover {
      background: #eef2fb;
      color: #185FA5;
      border-color: #c5d4f0;
    }
  }

  .action-menu {
    display: none;
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    min-width: 160px;
    box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
    z-index: 100;
    overflow: hidden;

    &.dropup {
      top: auto;
      bottom: calc(100% + 4px);
    }

    .menu-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 14px;
      font-size: 13px;
      color: #2d3748;
      cursor: pointer;
      transition: background 0.15s;

      i {
        width: 16px;
        font-size: 13px;
      }

      &.blue {
        color: #185FA5;

        i {
          color: #185FA5;
        }

        &:hover {
          background: #eef2fb;
          color: #1E6FB8;

          i {
            color: #1E6FB8;
          }
        }
      }

      &.success {
        color: #276749;

        i {
          color: #276749;
        }

        &:hover {
          background: #f0fdf4;
          color: #1d5230;

          i {
            color: #1d5230;
          }
        }
      }

      &.orange {
        color: #c05621;

        i {
          color: #c05621;
        }

        &:hover {
          background: #fff7ed;
          color: #9c4318;

          i {
            color: #9c4318;
          }
        }
      }

      &.purple {
        color: #6b46c1;

        i {
          color: #6b46c1;
        }

        &:hover {
          background: #f5f3ff;
          color: #553c9a;

          i {
            color: #553c9a;
          }
        }
      }

      &.danger {
        color: #c62828;

        i {
          color: #c62828;
        }

        &:hover {
          background: #fff5f5;
          color: #9b1c1c;

          i {
            color: #9b1c1c;
          }
        }
      }

      &.divider {
        border-top: 1px solid #f0f3fa;
        pointer-events: none;
        padding: 0;
        margin: 0;
      }
    }
  }

  &.open .action-menu {
    display: block;
  }
}

/* ── Empty / loading ── */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;

  i {
    font-size: 30px;
    display: block;
    margin-bottom: 10px;
    opacity: 0.45;
  }
}

/* ── Reset password overlay ── */
.reset-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(3px);

  .reset-card {
    background: #fff;
    border-radius: 16px;
    padding: 40px 48px;
    text-align: center;
    box-shadow: 0 20px 60px rgba(13, 27, 62, 0.25);
    max-width: 380px;

    i {
      font-size: 36px;
      color: #389ad4;
      display: block;
      margin-bottom: 16px;
    }

    h3 {
      font-size: 15px;
      font-weight: 700;
      color: #0d1b3e;
      margin-bottom: 8px;
    }

    p {
      font-size: 13px;
      color: #7a8499;
      margin: 0;

      strong {
        color: #0d1b3e;
      }
    }
  }
}

/* ── Custom modals ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9000;
  backdrop-filter: blur(3px);
  padding: 20px;
}

.confirm-dialog {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(13, 27, 62, 0.22);
  width: 100%;
  max-width: 420px;
  overflow: hidden;

  .modal-icon-wrap {
    display: flex;
    justify-content: center;
    padding: 28px 24px 0;

    .modal-icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;

      &.icon-danger {
        background: #fed7d7;
        color: #c62828;
      }

      &.icon-orange {
        background: #feebc8;
        color: #c05621;
      }

      &.icon-green {
        background: #c6f6d5;
        color: #276749;
      }

      &.icon-purple {
        background: #e9d8fd;
        color: #6b46c1;
      }
    }
  }

  .modal-body {
    padding: 20px 28px 24px;
    text-align: center;

    h3 {
      font-size: 16px;
      font-weight: 700;
      color: #0d1b3e;
      margin: 12px 0 8px;
    }

    p {
      font-size: 13px;
      color: #7a8499;
      margin: 0 0 4px;
      line-height: 1.6;
    }

    .modal-highlight {
      display: inline-block;
      margin-top: 10px;
      background: #f0f4fa;
      border-radius: 8px;
      padding: 8px 16px;
      font-size: 13px;
      font-weight: 600;
      color: #0d1b3e;
      word-break: break-all;
    }

    .modal-user-card {
      display: flex;
      align-items: center;
      gap: 12px;
      background: #f8fafd;
      border: 1px solid #e8edf5;
      border-radius: 10px;
      padding: 12px 16px;
      margin-top: 12px;
      text-align: left;

      .modal-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: linear-gradient(135deg, #553c9a, #6b46c1);
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        text-transform: uppercase;
      }

      .modal-user-info {
        .modal-user-name {
          font-size: 13px;
          font-weight: 700;
          color: #0d1b3e;
        }

        .modal-user-email {
          font-size: 12px;
          color: #7a8499;
          margin-top: 2px;
        }
      }
    }
  }

  /* Password form */
  .modal-form {
    padding: 0 28px 4px;
    text-align: left;

    .form-label {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      color: #7a8499;
      margin-bottom: 6px;
      display: block;
    }

    .password-input-wrap {
      position: relative;

      input {
        width: 100%;
        height: 40px;
        border: 1.5px solid #dde2ec;
        border-radius: 8px;
        padding: 0 42px 0 12px;
        font-size: 13px;
        color: #0d1b3e;
        outline: none;
        transition: border-color 0.2s;
        box-sizing: border-box;

        &:focus {
          border-color: #276749;
          box-shadow: 0 0 0 3px rgba(39, 103, 73, 0.1);
        }

        &.has-error {
          border-color: #e53e3e;
        }
      }

      .eye-btn {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        background: none;
        border: none;
        cursor: pointer;
        color: #a0aab8;
        font-size: 14px;
        padding: 0;

        &:hover {
          color: #4a5568;
        }
      }
    }

    .rules-list {
      margin-top: 12px;
      display: flex;
      flex-direction: column;
      gap: 5px;

      .rule-item {
        display: flex;
        align-items: center;
        gap: 7px;
        font-size: 12px;
        color: #a0aab8;
        transition: color 0.15s;

        i {
          font-size: 11px;
        }

        &.pass {
          color: #276749;
        }
      }
    }
  }

  .confirm-footer {
    display: flex;
    gap: 10px;
    padding: 16px 28px 24px;

    button {
      flex: 1;
      height: 40px;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;
      border: 1.5px solid;

      &.btn-cancel {
        background: #fff;
        color: #4a5568;
        border-color: #dde2ec;

        &:hover {
          border-color: #389ad4;
          color: #389ad4;
        }
      }

      &.btn-confirm-danger {
        background: #c62828;
        color: #fff;
        border-color: #c62828;

        &:hover {
          background: #9b1c1c;
          border-color: #9b1c1c;
        }
      }

      &.btn-confirm-orange {
        background: #c05621;
        color: #fff;
        border-color: #c05621;

        &:hover {
          background: #9c4318;
          border-color: #9c4318;
        }
      }

      &.btn-confirm-green {
        background: #276749;
        color: #fff;
        border-color: #276749;

        &:hover {
          background: #1d5230;
          border-color: #1d5230;
        }
      }

      &.btn-confirm-purple {
        background: #6b46c1;
        color: #fff;
        border-color: #6b46c1;

        &:hover {
          background: #553c9a;
          border-color: #553c9a;
        }
      }
    }
  }
}

/* ── User avatar initials ── */
.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1E6FB8, #389ad4);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-transform: uppercase;
}

.user-cell {
  display: flex;
  align-items: center;
  gap: 10px;

  .user-name {
    font-weight: 500;
    color: #0d1b3e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.cell-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
</style>

<template>
  <div class="page-wrap">

    <!-- Reset password overlay -->
    <div class="reset-overlay" v-if="resetPassowordStatus">
      <div class="reset-card">
        <i class="fa fa-paper-plane"></i>
        <h3>Sending Reset Link…</h3>
        <p>Sending password reset to<br /><strong>{{ email }}</strong></p>
      </div>
    </div>

    <!-- Edit / Create user modal -->
    <v-update-user-detail :show-modal="showModalUserUpdate" v-on:closemodal="closemodal" :edit="edit"
      :location_id="location_id" :user-details="updateUserDetail" />

    <!-- ─── Delete Modal ─── -->
    <div class="modal-overlay" v-if="activeModal === 'delete'" @click.self="activeModal = null">
      <div class="confirm-dialog">
        <div class="modal-icon-wrap">
          <div class="modal-icon icon-danger"><i class="fa fa-trash"></i></div>
        </div>
        <div class="modal-body">
          <h3>Delete User</h3>
          <p>Are you sure you want to delete <strong>{{ modalItem && modalItem.name }}</strong>?<br />This action cannot
            be undone.</p>
        </div>
        <div class="confirm-footer">
          <button class="btn-cancel" @click="activeModal = null">Cancel</button>
          <button class="btn-confirm-danger" @click="confirmDelete">Delete</button>
        </div>
      </div>
    </div>

    <!-- ─── Reset Password Modal ─── -->
    <div class="modal-overlay" v-if="activeModal === 'reset'" @click.self="activeModal = null">
      <div class="confirm-dialog">
        <div class="modal-icon-wrap">
          <div class="modal-icon icon-orange"><i class="fa fa-sync"></i></div>
        </div>
        <div class="modal-body">
          <h3>Reset Password</h3>
          <p>A new password will be sent to:</p>
          <span class="modal-highlight">{{ modalItem && modalItem.email }}</span>
        </div>
        <div class="confirm-footer">
          <button class="btn-cancel" @click="activeModal = null">Cancel</button>
          <button class="btn-confirm-orange" @click="confirmReset">Send Reset</button>
        </div>
      </div>
    </div>

    <!-- ─── Set Password Modal ─── -->
    <div class="modal-overlay" v-if="activeModal === 'setPassword'" @click.self="activeModal = null">
      <div class="confirm-dialog">
        <div class="modal-icon-wrap">
          <div class="modal-icon icon-green"><i class="fa fa-key"></i></div>
        </div>
        <div class="modal-body">
          <h3>Set New Password</h3>
          <p>For user: <strong>{{ modalItem && modalItem.username }}</strong></p>
        </div>
        <div class="modal-form">
          <label class="form-label">New Password</label>
          <div class="password-input-wrap">
            <input :type="showPassword ? 'text' : 'password'" v-model="newPassword" placeholder="Enter new password"
              :class="{ 'has-error': passwordError }" />
            <button type="button" class="eye-btn" @click="showPassword = !showPassword">
              <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
          </div>
          <p v-if="passwordError" style="color:#e53e3e; font-size:12px; margin:6px 0 0; text-align:left;">{{
            passwordError }}</p>
          <div class="rules-list">
            <div v-for="rule in rules" :key="rule.message" class="rule-item"
              :class="{ pass: rule.regex.test(newPassword) }">
              <i :class="rule.regex.test(newPassword) ? 'fa fa-check-circle' : 'fa fa-circle'"></i>
              {{ rule.message }}
            </div>
          </div>
        </div>
        <div class="confirm-footer">
          <button class="btn-cancel" @click="activeModal = null">Cancel</button>
          <button class="btn-confirm-green" @click="confirmSetPassword">Save Password</button>
        </div>
      </div>
    </div>

    <!-- ─── Login As Modal ─── -->
    <div class="modal-overlay" v-if="activeModal === 'loginAs'" @click.self="activeModal = null">
      <div class="confirm-dialog">
        <div class="modal-icon-wrap">
          <div class="modal-icon icon-purple"><i class="fa fa-sign-in-alt"></i></div>
        </div>
        <div class="modal-body">
          <h3>Login As User</h3>
          <p>You will be logged in as this user.</p>
          <div class="modal-user-card" v-if="modalItem">
            <div class="modal-avatar">{{ (modalItem.name || '?').charAt(0) }}</div>
            <div class="modal-user-info">
              <div class="modal-user-name">{{ modalItem.name }}</div>
              <div class="modal-user-email">{{ modalItem.email }}</div>
            </div>
          </div>
        </div>
        <div class="confirm-footer">
          <button class="btn-cancel" @click="activeModal = null">Cancel</button>
          <button class="btn-confirm-purple" @click="confirmLoginAs">Login</button>
        </div>
      </div>
    </div>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <span class="panel-title">
          <i class="fa fa-users"></i>
          Users
          <span v-if="client.name">—</span>
          <span class="provider-name" v-if="client.name">{{ client.name }}</span>
          <span style="font-size:12px; color:#7a8499; font-weight:400;" v-if="filteredUsers.length">
            ({{ filteredUsers.length }})
          </span>
        </span>
        <button class="btn-back" @click="goBack()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>

      <!-- Toolbar -->
      <div class="toolbar">
        <div class="search-box">
          <i class="fa fa-search"></i>
          <input type="text" autocomplete="off" v-model="searchInput" placeholder="Search users…" />
        </div>
        <button class="btn-add" @click="openmodel()">
          <i class="fa fa-plus"></i> Add User
        </button>
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="loadingData">
        <i class="fa fa-spinner fa-spin"></i>
        Loading users…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="filteredUsers.length === 0">
        <i class="fa fa-user-o"></i>
        No users found
      </div>

      <!-- Table -->
      <div v-else>
        <table class="users-table">
          <thead>
            <tr>
              <th style="width:32px;">#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Username</th>
              <th style="width:76px; text-align:right;">Status</th>
              <th style="width:82px; text-align:right;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredUsers" :key="item.id">
              <td style="color:#a0aab8; font-size:12px;">{{ index + 1 }}</td>
              <td>
                <div class="user-cell">
                  <span class="user-avatar">{{ (item.name || '?').charAt(0) }}</span>
                  <span class="user-name">{{ item.name }}</span>
                </div>
              </td>
              <td><span class="cell-truncate" style="color:#4a5568;">{{ item.email }}</span></td>
              <td><span class="cell-truncate" style="color:#4a5568; font-size:12px; font-family:monospace;">{{
                  item.username }}</span></td>
              <td style="text-align:right;">
                <label class="switch-wrap">
                  <input type="checkbox" v-model="item.is_active"
                    @change="updateServiceStatus(index, item.id, item.is_active, item.username)" />
                  <span class="slider"></span>
                </label>
              </td>
              <td style="text-align:right; overflow:visible;" @click.stop>
                <div class="action-wrap" :class="{ open: openIndex === index }"
                  @click.stop="toggleDropdown(index, $event)" :ref="`dropdown-${index}`">
                  <div class="action-btn">•••</div>
                  <div class="action-menu" :class="{ dropup: dropupIndex === index }">
                    <div class="menu-item blue" @click.stop="openUserUpdateModal(item)">
                      <i class="fa fa-pencil-alt"></i> Edit
                    </div>
                    <div class="menu-item orange" @click.stop="openResetModal(item)">
                      <i class="fa fa-sync"></i> Reset Password
                    </div>
                    <div class="menu-item success" @click.stop="openSetPasswordModal(item)">
                      <i class="fa fa-key"></i> Set Password
                    </div>
                    <div class="menu-item purple" v-if="item.is_active && currentUser.u.is_admin == 1"
                      @click.stop="openLoginAsModal(item)">
                      <i class="fa fa-sign-in-alt"></i> Login As
                    </div>
                    <div class="menu-item divider"></div>
                    <div class="menu-item danger" @click.stop="openDeleteModal(item)">
                      <i class="fa fa-trash"></i> Delete
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  FETCH_B_LOCATION_USER,
  RESET_USER_PASSWORD,
  UPDATE_B_USER,
  EMAIL_PASSWORD_B_USER,
  DELETE_B_USER,
  FETCH_ROLES,
  IMPERSONATE_USER
} from "@/core/services/store/actions.type";
import vUpdateUserDetail from "@/components/frontend/modal/updateuserdetail";
import { mapGetters } from "vuex";
import vDataLoader from "@/components/frontend/spinner.vue";

export default {
  components: { vDataLoader, vUpdateUserDetail },
  computed: {
    ...mapGetters(["currentUser", "getRoleData"]),
    filteredUsers() {
      let list = this.users;
      if (this.searchInput) {
        list = list.filter(item =>
          item.name.toUpperCase().includes(this.searchInput.toUpperCase())
        );
      }
      return list;
    }
  },
  data() {
    return {
      rules: [
        { message: "One lowercase letter required.", regex: /[a-z]+/ },
        { message: "One uppercase letter required.", regex: /[A-Z]+/ },
        { message: "8 characters minimum.", regex: /.{8,}/ },
        { message: "One number required.", regex: /[0-9]+/ },
        { message: "One special character required.", regex: /[!@#$%^&*]+/ }
      ],
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Service Provider Locations", route: "admin.serviceprovider.index" },
        { id: 3, title: "Users", route: "" }
      ],
      loadingData: false,
      searchInput: "",
      users: [],
      client: [],
      resetPassowordStatus: "",
      email: "",
      showModalUserUpdate: false,
      updateUserDetail: {},
      edit: true,
      location_id: "",
      openIndex: null,
      dropupIndex: null,
      activeModal: null,
      modalItem: null,
      newPassword: "",
      showPassword: false,
      passwordError: ""
    };
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.getUserData();
    this.$store.dispatch(FETCH_ROLES);
    this.location_id = parseInt(this.$route.params.id);
    document.addEventListener("click", this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
  },
  methods: {
    closemodal(status) {
      this.showModalUserUpdate = false;
      if (status) this.getUserData();
    },
    openDeleteModal(item) {
      this.modalItem = item;
      this.activeModal = "delete";
      this.openIndex = null;
    },
    confirmDelete() {
      this.$store.dispatch(DELETE_B_USER, this.modalItem.id)
        .then(data => { this.$toastr.s(data.msg); this.getUserData(); });
      this.activeModal = null;
    },
    openmodel() {
      this.updateUserDetail = { first_name: "", last_name: "", email: "", username: "", name: "", roles: "staff", user_role: "" };
      this.showModalUserUpdate = true;
      this.edit = false;
    },
    openUserUpdateModal(data) {
      this.updateUserDetail = data;
      this.showModalUserUpdate = true;
      this.edit = true;
    },
    goBack() {
      if (this.$route.name === "admin.serviceprovider.location.users") {
        this.$router.push({ name: "admin.serviceprovider.index" });
      } else {
        this.$router.push({ name: "client.location", params: { client_slug: this.$route.params.client_slug } });
      }
    },
    openSetPasswordModal(item) {
      this.modalItem = item;
      this.newPassword = "";
      this.showPassword = false;
      this.passwordError = "";
      this.activeModal = "setPassword";
      this.openIndex = null;
    },
    confirmSetPassword() {
      if (!this.newPassword) {
        this.passwordError = "Please enter a password.";
        return;
      }
      for (let rule of this.rules) {
        if (!rule.regex.test(this.newPassword)) {
          this.passwordError = rule.message;
          return;
        }
      }
      this.passwordError = "";
      this.$store.dispatch(EMAIL_PASSWORD_B_USER, { user_id: this.modalItem.id, password: this.newPassword })
        .then(data => { this.$toastr.s(data.msg); })
        .catch(err => { this.$toastr.e(err?.error?.password || "Failed to set password."); });
      this.activeModal = null;
    },
    updateServiceStatus(index, id, flag, username) {
      const revert = !flag;
      this.$swal.fire({
        title: "Change status?",
        text: "Change the status of user: " + username + "?",
        confirmButtonText: "Save",
        cancelButtonText: "Cancel",
        showCancelButton: true
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(UPDATE_B_USER, { id, data: { is_active: flag, status_: true } })
            .then(data => { this.$toastr.s(data.msg); })
            .catch(err => { this.errors = err; });
        } else {
          this.filteredUsers[index].is_active = revert;
        }
      });
    },
    openResetModal(item) {
      this.modalItem = item;
      this.activeModal = "reset";
      this.openIndex = null;
    },
    confirmReset() {
      this.email = this.modalItem.email;
      this.resetPassowordStatus = true;
      this.activeModal = null;
      this.$store.dispatch(RESET_USER_PASSWORD, { email: this.modalItem.email, client_slug: this.client.slug })
        .then(data => { this.resetPassowordStatus = false; this.$toastr.s(data.msg); })
        .catch(() => { this.resetPassowordStatus = false; });
    },
    getUserData() {
      this.loadingData = true;
      this.$store.dispatch(FETCH_B_LOCATION_USER, this.$route.params.id)
        .then(data => {
          this.client = data.client;
          this.users = data.users;
          this.breadCrumbs[2].title = "Users | " + this.client.name;
          this.loadingData = false;
        })
        .catch(() => { this.loadingData = false; });
    },
    openLoginAsModal(item) {
      this.modalItem = item;
      this.activeModal = "loginAs";
      this.openIndex = null;
    },
    confirmLoginAs() {
      this.activeModal = null;
      window.localStorage.removeItem("search");
      window.localStorage.removeItem("appoitmentsearch");
      this.$store.dispatch(IMPERSONATE_USER, { user_id: this.modalItem.id })
        .then(data => {
          if (data.slug) {
            this.$router.push({ name: "client.dashboard", params: { client_slug: data.slug } })
              .then(() => window.location.reload());
          }
        });
    },
    toggleDropdown(index, event) {
      this.openIndex = this.openIndex === index ? null : index;
      if (this.openIndex === index) {
        this.$nextTick(() => {
          const el = event.currentTarget;
          const menu = el.querySelector(".action-menu");
          if (menu) {
            const rect = el.getBoundingClientRect();
            this.dropupIndex = (window.innerHeight - rect.bottom) < (menu.scrollHeight || 160) + 30 ? index : null;
          }
        });
      } else {
        this.dropupIndex = null;
      }
    },
    closeDropdown() {
      this.openIndex = null;
      this.dropupIndex = null;
    }
  }
};
</script>
